import { makeStyles } from "@saleor/macaw-ui";
interface propsType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsType>(
  theme => ({
    menu: {
      padding: 0,
      position: "fixed",
      bottom: 0,
      transition: "width 0.4s ease",
      width: "100%",
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${88 * 2}px)`
      }
    },
    wrapper: {
      display: "block",
      width: "100%",
      alignItems: "center",
      boxShadow: "0px -8px 24px rgb(0 0 0 / 8%)",
      borderRadius: "20px 20px 0px 0px"
    },
    section: {
      display: "flex",
      padding: "1.6rem 2.4rem",
      justifyContent: "space-between",
      gap: "0 2.4rem"
    },
    sectionBtn: {
      display: "flex",
      padding: "1.6rem 2.4rem",
      justifyContent: "space-between"
    },
    sectionBtnLeft: {
      display: "flex",
      gap: "0 1.6rem"
    },
    btnChangeOrder: {
      padding: "12px 28px 12px 30px",
      background: `linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)`
    },
    divider: {
      margin: 0,
      border: 0,
      borderTop: `1px dashed ${theme.palette.grey[500]}`
    },
    summaryCaption: {
      color: theme.palette.grey[900]
    },
    number: {
      fontSize: "1.8rem",
      lineHeight: "2.4rem"
    },
    price: {
      display: "block",
      float: "left",
      minWidth: 152,
      "&:not(:last-child)": {
        marginRight: "2.4rem"
      }
    },
    priceCurrency: {
      display: "block",
      float: "left",
      minWidth: 100,
      "&:not(:last-child)": {
        marginRight: "2.4rem"
      }
    },
    priceCaption: {
      color: theme.palette.grey[600],
      marginBottom: "0.6rem"
    },
    netPriceNumber: {
      color: theme.palette.info.dark
    },
    currency: {
      textTransform: "uppercase"
    },
    btnAddProduct: {
      alignItems: "center",
      height: 48,
      padding: "12px 36px",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    btnConfirmOrder: {
      color: "#ffffff",
      alignItems: "center",
      fontSize: "1.8rem",
      lineHeight: "2.8rem",
      height: 48,
      padding: "12px 34px",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    }
  }),
  { name: "CreateOrderFooter" }
);

export default useStyles;
